/**
 * Reducer for the global application context.
 * @type {AppReducer} appReducer
 */
export default function appReducer(state, action) {
  switch (action.type) {
    // AUTH REDUCERS
    case 'SET_AUTHENTICATION': {
      return { ...state, isAuthenticated: true };
    }

    case 'SET_USER': {
      return { ...state, user: action.payload };
    }

    case 'DELETE_AUTHENTICATION': {
      return { ...state, isAuthenticated: false, user: undefined };
    }
    // MESSAGES REDUCERS
    case 'SET_MESSAGE': {
      const message = {
        id: state.messages.length + 1,
        isSelfClosing: true,
        ...action.payload,
      };
      const messages = state.messages.concat(message);
      return { ...state, messages };
    }
    case 'DELETE_MESSAGE': {
      const messages = state.messages.filter((message) => message.id !== action.payload);
      return { ...state, messages };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
